import apiService from '../services/APIService';
import Response from '../modules/classes/Response';
import User from '../models/User_b';

class UserController {
  constructor(apiService) {
    this.apiService = apiService;
    this.mediaController = new UserMediaController(apiService);
  }
  // async getUser(userId) {
  //   return new Promise((resolve, reject) => {
  //     apiService.get(`/users/${userId}/profile`).then((res) => {
  //       const response = Response.parse(res);
  //       resolve(User.fromData(response.data));
  //     }).catch((err) => {
  //       reject(err);
  //     });
  //   });
  // }

  getService() {
    return this.apiService ? this.apiService : apiService;
  }

  async getUserWithToken(userId, token) {
    return new Promise((resolve, reject) => {
      this.getService().get(`/users/${userId}`, { token }).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async updateUser(data) {
    return new Promise((resolve, reject) => {
      this.getService().patch(`/users/me`, data).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async onBoardedUser() {
    return new Promise((resolve, reject) => {
      this.getService().patch(`/users/me/onboarded`, {}).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    }); 
  }

  async getProfile() {
    return new Promise((resolve, reject) => {
      this.getService().get(`/users/me`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getUser(userId, additional = null) {

    return new Promise((resolve, reject) => {
      this.getService().get(`/users/${userId}/profile`).then((res) => {
        resolve(User.fromData(res.data, additional));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getProfileWithToken(token) {
    return new Promise((resolve, reject) => {
      this.getService().get(`/users/me`, { token }).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async deactivate() {
    return new Promise((resolve, reject) => {
      this.getService().delete(`/users/me/deactivate`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async Me() {
    return new Promise((resolve, reject) => {
      this.getService().get(`/users/me`).then((res) => {
        resolve(User.fromData(res.data));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async updateAvatar(avatar) {

    // Create file object from uri
    const fileData = {
      uri: avatar,
      type: 'image/jpeg', // Assuming JPEG format, adjust if needed
      name: 'avatar.jpg'
    };

    const formData = new FormData();

    formData.append('avatar', fileData);

    return new Promise((resolve, reject) => {
      this.getService().requestWithFormData('/users/me', 'PATCH', formData).then(async (res) => {
            resolve(Response.parse(res));
        }).catch((err) => {
            reject(err);
        });
    });
  }

  async updateBanner(banner) {
    const fileData = {
      uri: banner,
      type: 'image/jpeg', // Assuming JPEG format, adjust if needed
      name: 'banner.jpg'
    };

    const formData = new FormData();

    formData.append('banner', fileData);

    return new Promise((resolve, reject) => { 
      this.getService().requestWithFormData('/users/me', 'PATCH', formData).then(  (res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async updateProfile(formData) {
    return new Promise((resolve, reject) => {
      this.getService().requestWithFormData('/users/me', 'PATCH', formData).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async updateInterests(interests, companies = []) {
    return new Promise((resolve, reject) => {
      const payload = {};
      if (Array.isArray(interests) && interests.length > 0) {
        payload.interests = interests;
      }
      if (Array.isArray(companies) && companies.length > 0) {
        payload.companies = companies;
      }

      this.getService().patch('/users/me/interests', payload).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getUserSuggestions(page = 1, limit = 10) {
    return new Promise((resolve, reject) => {
      this.getService().get(`/users/suggestions/for-you`, {
        params: { page, limit }
      }).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async followUser(userId) {
    return new Promise((resolve, reject) => {
      this.getService().post(`/follows/${userId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async unfollowUser(userId) {
    return new Promise((resolve, reject) => {
      this.getService().delete(`/follows/${userId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

class UserSettingController {
    constructor(user) {
        this.user = user;
    }

  getSettings() {
    return this.user.settings;
  }

  updateSettings(settings) {
    return new Promise((resolve, reject) => {
      apiService.patch(`/users/me/settings`, settings).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

class UserMediaController {
  getAllMedias() {
    return new Promise((resolve, reject) => {
      apiService.get(`/users/me/all-media`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

const defaultUserController = new UserController(null);

export { UserController, UserSettingController, UserMediaController, defaultUserController };

export default UserController;